export default "__VITE_ASSET__Ws58dy_w__"